/**
 * Converts a JavaScript Date object to ISO date string format (YYYY-MM-DD)
 * Uses UTC methods to avoid timezone-related date shifting issues
 *
 * @param date - JavaScript Date object
 * @returns ISO formatted date string (e.g., "2025-11-14")
 */
export function formatDateToISO(date: Date): string {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}
